import * as VueRouter from 'vue-router'
import routes from './routes'
import { store } from './vuex'

let vueRouter = VueRouter.createRouter({
    history: VueRouter.createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash };
        }

        return { x: 0, y: 0 };
    }
});

const IS_LEGACY = (document.getElementById('legacyHeader') !== null);

vueRouter.beforeEach(async function(to, from, next) {
    if (to.path.startsWith('/manage')) {
        const tokenExpired = await store.dispatch('auth/tokenIsExpired');
        if (tokenExpired) {
            await store.dispatch('auth/getTokenFromSession');
        }
    }
    next();

    if (to.meta.constructor === Object && to.meta.hasOwnProperty('legacyPath') && to.meta.legacyPath) {
        window.location = to.meta.legacyPath;
        return false;
    }

    if (IS_LEGACY && window.location.pathname !== to.path) {
        window.location = to.path;
        return false;
    }

    if (to.meta.constructor === Object && to.meta.hasOwnProperty('public') && to.meta.public) {
        // this route does not require auth, but if the user is authed and they are
        // requesting the login page then check to see if it was from the legacy system
        // if not then push them to the dashboard

        if (to.name == 'login' && store.state.auth.loggedIn) {
            console.log(to);
            if (to.query.requestedUrl != undefined) {
                await store.dispatch('auth/setLegacySession');
                try {
                    const dest = new URL(atob(to.query.requestedUrl), window.location.origin);
                    const allowedHosts = [window.location.host /*, other known Ambassador hosts */];
                    if ((dest.protocol === 'https:' || dest.protocol === 'http:') && allowedHosts.includes(dest.host)) {
                        window.location = dest.href;
                    } else {
                        return next({ name: 'dashboard' });
                    }
                } catch (e) {
                    return next({ name: 'dashboard' });
                }
            }
            return next({ name: 'dashboard' });
        }
        return next();
    }


    if (await store.dispatch('auth/tokenIsExpired')) {
        if (store.state.auth.hasOwnProperty('token')
            && store.state.auth.token
            && store.state.auth.token.constructor === Object
            && store.state.auth.token.hasOwnProperty('refresh_token')
            && store.state.auth.token.refresh_token !== null
        ) {
            let response = await store.dispatch('auth/refresh');
            if (!response) {
                localStorage.clear();
                return next({name: 'login', params: {previousPath: to.fullPath}});
            }
        } else {
            localStorage.clear();
            return next({name: 'login', params: {previousPath: to.fullPath}});
        }

        if (store.getters['auth/tokenIsExpired']) {
            store.commit('alert/setDangerAlert', 'You\'re session has expired, please log in again');
            store.commit('auth/setIsLoggedOut');
            return next({name: 'login', params: {previousPath: to.fullPath}});
        }
    }

    return next();
});


export const router = vueRouter;
